/* Printtex — outil de la page « Préparer mon visuel » (section printtex-visuel.liquid). Module ES, sans framework.
   Rogner, retirer le fond (uni : ici ; photo : module IA au clic), vectoriser, améliorer la netteté, avant/après,
   télécharger ou envoyer vers la feuille DTF / l'outil de personnalisation (printtex-visuel-transfert.js).
   Jamais de blocage : la qualité donne un avis, le client décide. */
import { conseilTaille, pixelsPour, typeFond } from './printtex-visuel-qualite.js';

const root = document.querySelector('[data-pvis]');
if (root) {
  const $ = (s) => root.querySelector(s);
  const fichier = $('[data-fichier]'), depot = $('[data-depot]'), msg = $('[data-msg]'), travail = $('[data-travail]');
  const largeur = $('[data-largeur]'), avis = $('[data-avis]'), apercu = $('[data-apercu]');
  const cvAvant = $('[data-avant]'), cvApres = $('[data-apres]'), curseur = $('[data-curseur]'), cadre = $('[data-cadre]');
  const limite = $('[data-limite]'), progres = $('[data-progres]'), barre = $('[data-progres-barre]'), progresTexte = $('[data-progres-texte]');
  const btn = (a) => $(`[data-action="${a}"]`);
  const TOL = 42;
  const MAX_PX = 16e6; // limite des toiles de Safari iOS (16,7 Mpx)
  const APERCU_MAX = 1400; // côté max des toiles d'aperçu (l'image réelle garde sa taille)
  let original = null, courant = null, precedent = null, svg = null, nom = 'visuel', occupe = false, rognage = null;

  const dire = (t, type = 'info') => { msg.hidden = !t; msg.textContent = t || ''; msg.dataset.type = type; };
  const LIMITES = {
    rogner: 'Déplacez le cadre ou ses coins, puis appuyez sur « Valider le recadrage ».',
    fond: 'Fond uni : retiré tout de suite. Photo : un module d’intelligence artificielle se charge (quelques secondes la première fois). Le résultat n’est pas toujours parfait sur les cheveux et les bords fins.',
    vecto: 'Pour les logos et dessins simples (aplats, peu de couleurs). Ne convient pas aux photos.',
    nettete: 'Utile sur une image un peu petite (×2). Ne rattrape pas une image très floue.',
  };
  const ERREURS = {
    reseau: 'Le module n’a pas pu se charger. Vérifiez votre connexion internet et réessayez.',
    memoire: 'Votre appareil manque de mémoire pour cette image. Essayez sur un ordinateur, ou envoyez-nous le fichier : on s’en occupe.',
    'trop-gros': 'Fichier trop lourd pour être transmis dans ce mode de navigation (privée) : téléchargez-le, puis importez-le sur la page suivante.',
  };

  const toile = (w, h) => { const c = document.createElement('canvas'); c.width = w; c.height = h; return [c, c.getContext('2d', { willReadFrequently: true })]; };
  const versBlob = async (bmp) => { const [c, x] = toile(bmp.width, bmp.height); x.drawImage(bmp, 0, 0); return new Promise((ok) => c.toBlob(ok, 'image/png')); };

  function dessiner(cv, bmp) {
    const k = Math.min(1, APERCU_MAX / Math.max(bmp.width, bmp.height));
    cv.width = Math.round(bmp.width * k); cv.height = Math.round(bmp.height * k);
    const x = cv.getContext('2d'); x.clearRect(0, 0, cv.width, cv.height); x.drawImage(bmp, 0, 0, cv.width, cv.height);
  }
  function afficher() {
    dessiner(cvAvant, original); dessiner(cvApres, courant);
    apercu.style.aspectRatio = `${courant.width} / ${courant.height}`;
    apercu.style.width = `min(100%, calc(70vh * ${courant.width / courant.height}))`; // la boîte suit l'image : le cadre de recadrage tombe juste
    cvAvant.style.aspectRatio = `${original.width} / ${original.height}`;
    couper();
    const l = parseFloat(String(largeur.value).replace(',', '.')) || 28;
    const c = conseilTaille(courant.width, l);
    avis.textContent = `${courant.width} × ${courant.height} px. ${c.message}`; avis.dataset.niveau = c.niveau;
    btn('annuler').disabled = !precedent; btn('original').disabled = courant === original;
  }
  const couper = () => { cvApres.style.clipPath = `inset(0 0 0 ${curseur.value}%)`; };

  async function ouvrir(f) {
    if (!f) return;
    dire('');
    try {
      let bmp = await createImageBitmap(f);
      if (bmp.width * bmp.height > MAX_PX) {
        const k = Math.sqrt(MAX_PX / (bmp.width * bmp.height));
        const r = await createImageBitmap(bmp, { resizeWidth: Math.floor(bmp.width * k), resizeHeight: Math.floor(bmp.height * k), resizeQuality: 'high' });
        bmp.close(); bmp = r;
        setTimeout(() => dire(`Image très grande : réduite à ${bmp.width} × ${bmp.height} px pour que votre téléphone puisse la traiter. C’est largement assez pour l’impression.`), 0);
      }
      original = courant = bmp; precedent = null; svg = null; nom = (f.name || 'visuel').replace(/\.[^.]+$/, '');
      travail.hidden = false; limite.textContent = ''; arreterRognage(); afficher();
    } catch (e) {
      dire('Ce fichier ne s’ouvre pas ici (format HEIC d’iPhone, PDF, fichier abîmé…). Sur iPhone, choisissez « Format le plus compatible » dans Réglages > Appareil photo > Formats, ou envoyez-nous le fichier tel quel : on s’en occupe.', 'erreur');
    }
    fichier.value = '';
  }
  fichier.addEventListener('change', () => ouvrir(fichier.files[0]));
  ['dragenter', 'dragover'].forEach((e) => depot.addEventListener(e, (ev) => { ev.preventDefault(); depot.classList.add('is-over'); }));
  ['dragleave', 'drop'].forEach((e) => depot.addEventListener(e, (ev) => { ev.preventDefault(); depot.classList.remove('is-over'); }));
  depot.addEventListener('drop', (ev) => ouvrir(ev.dataTransfer.files[0]));
  largeur.addEventListener('input', () => courant && afficher());
  curseur.addEventListener('input', couper);
  root.querySelectorAll('[data-voir]').forEach((b) => b.addEventListener('click', () => {
    apercu.dataset.fond = b.dataset.voir;
    root.querySelectorAll('[data-voir]').forEach((x) => x.setAttribute('aria-pressed', String(x === b)));
  }));

  function appliquer(bmp, nouveauSvg = null) { precedent = { courant, svg }; courant = bmp; svg = nouveauSvg; afficher(); }

  async function enCours(texte, travailFn) {
    if (occupe) return; occupe = true;
    root.querySelectorAll('[data-action], [data-fin]').forEach((b) => { b.dataset.etait = b.disabled; b.disabled = true; });
    progres.hidden = false; barre.style.width = '0%'; progresTexte.textContent = texte;
    await new Promise((r) => requestAnimationFrame(() => setTimeout(r, 0))); // affiche la barre avant le calcul
    try { await travailFn((p) => { barre.style.width = `${p}%`; }); dire(''); } catch (e) { dire(ERREURS[e.message] || ERREURS.reseau, 'erreur'); }
    finally {
      occupe = false; progres.hidden = true;
      root.querySelectorAll('[data-action], [data-fin]').forEach((b) => { b.disabled = b.dataset.etait === 'true'; });
      if (courant) afficher();
    }
  }

  // Pourtour de l'image (pour savoir si le fond est transparent, uni ou une photo).
  // Travail sur une copie de 4 Mpx au plus : rapide et sans saturer la mémoire d'un téléphone.
  function bord(bmp) {
    const k = Math.min(1, Math.sqrt(4e6 / (bmp.width * bmp.height)));
    const w = Math.max(1, Math.round(bmp.width * k)), h = Math.max(1, Math.round(bmp.height * k));
    const [, x] = toile(w, h); x.drawImage(bmp, 0, 0, w, h);
    const d = x.getImageData(0, 0, w, h).data, px = [];
    const pas = Math.max(1, Math.floor((2 * (w + h)) / 4000));
    for (let i = 0; i < w; i += pas) px.push(i, (h - 1) * w + i);
    for (let j = 0; j < h; j += pas) px.push(j * w, j * w + w - 1);
    const out = new Uint8ClampedArray(px.length * 4);
    px.forEach((p, k) => out.set(d.subarray(p * 4, p * 4 + 4), k * 4));
    return { type: typeFond(out), x, d, w, h, med: [0, 1, 2].map((c) => { const v = px.map((p) => d[p * 4 + c]).sort((a, b) => a - b); return v[v.length >> 1]; }) };
  }

  // Fond uni : retiré seulement autour du visuel (remplissage depuis les bords), les blancs intérieurs sont gardés.
  async function retirerFondUni(b) {
    const { x, d, w, h, med } = b;
    const vu = new Uint8Array(w * h), pile = []; // copie ≤ 4 Mpx : pile raisonnable
    const proche = (p) => Math.max(Math.abs(d[p * 4] - med[0]), Math.abs(d[p * 4 + 1] - med[1]), Math.abs(d[p * 4 + 2] - med[2])) <= TOL;
    for (let i = 0; i < w; i++) pile.push(i, (h - 1) * w + i);
    for (let j = 0; j < h; j++) pile.push(j * w, j * w + w - 1);
    while (pile.length) {
      const p = pile.pop();
      if (vu[p] || !proche(p)) continue;
      vu[p] = 1; d[p * 4 + 3] = 0;
      const px = p % w;
      if (px > 0) pile.push(p - 1); if (px < w - 1) pile.push(p + 1);
      if (p >= w) pile.push(p - w); if (p < w * (h - 1)) pile.push(p + w);
    }
    x.putImageData(new ImageData(d, w, h), 0, 0);
    // Masque calculé sur la copie, appliqué à l'image en pleine taille.
    const [c, xx] = toile(courant.width, courant.height);
    xx.drawImage(x.canvas, 0, 0, courant.width, courant.height);
    xx.globalCompositeOperation = 'source-in';
    xx.drawImage(courant, 0, 0);
    return createImageBitmap(c);
  }

  const modules = () => import('./printtex-visuel-modules.js');

  btn('fond').addEventListener('click', () => {
    limite.textContent = LIMITES.fond;
    enCours('Analyse de l’image…', async (p) => {
      const b = bord(courant);
      if (b.type === 'transparent') { setTimeout(() => dire('Le fond est déjà transparent : rien à retirer.'), 0); return; }
      if (b.type === 'uni') { progresTexte.textContent = 'Retrait du fond…'; appliquer(await retirerFondUni(b)); return; }
      progresTexte.textContent = 'Chargement du module de détourage (première fois : quelques secondes)…';
      const m = await modules();
      progresTexte.textContent = 'Détourage de la photo…';
      appliquer(await m.retirerFondPhoto(courant, p));
    });
  });

  btn('vecto').addEventListener('click', () => {
    limite.textContent = LIMITES.vecto;
    enCours('Vectorisation…', async (p) => {
      const photo = bord(courant).type === 'complexe';
      const m = await modules();
      const v = await m.vectoriser(courant);
      const png = await v.png(Math.max(courant.width, pixelsPour(Math.min(35, parseFloat(largeur.value) || 28)))); p(100);
      appliquer(await createImageBitmap(png), v.svg);
      if (photo) setTimeout(() => dire('Cette image ressemble à une photo : la vectorisation risque de l’abîmer. « Annuler la dernière étape » la remet comme avant.', 'attention'), 0);
    });
  });

  btn('nettete').addEventListener('click', () => {
    limite.textContent = LIMITES.nettete;
    if (courant.width * courant.height > 4e6) { dire('Votre image est déjà grande : l’améliorer n’apporterait rien.'); return; }
    enCours('Chargement du module de netteté (première fois : quelques secondes)…', async (p) => {
      const m = await modules();
      progresTexte.textContent = 'Amélioration de la netteté…';
      appliquer(await m.ameliorerNettete(courant, p));
    });
  });

  btn('annuler').addEventListener('click', () => { if (!precedent) return; ({ courant, svg } = precedent); precedent = null; afficher(); });
  btn('original').addEventListener('click', () => { precedent = { courant, svg }; courant = original; svg = null; afficher(); });

  /* Rognage : cadre en % de l'aperçu ; on le déplace (glisser dedans) ou on tire un coin. */
  function arreterRognage() { rognage = null; cadre.hidden = true; btn('rogner').textContent = 'Rogner'; curseur.hidden = false; }
  function placerCadre() { const r = rognage; Object.assign(cadre.style, { left: `${r.x}%`, top: `${r.y}%`, width: `${r.w}%`, height: `${r.h}%` }); }
  btn('rogner').addEventListener('click', async () => {
    if (!rognage) {
      limite.textContent = LIMITES.rogner;
      rognage = { x: 5, y: 5, w: 90, h: 90 }; placerCadre(); cadre.hidden = false; curseur.value = 0; couper(); curseur.hidden = true;
      btn('rogner').textContent = 'Valider le recadrage';
      return;
    }
    const r = rognage, W = courant.width, H = courant.height;
    const sx = Math.round((r.x / 100) * W), sy = Math.round((r.y / 100) * H);
    const sw = Math.max(1, Math.round((r.w / 100) * W)), sh = Math.max(1, Math.round((r.h / 100) * H));
    arreterRognage(); curseur.value = 50;
    appliquer(await createImageBitmap(courant, sx, sy, sw, sh));
  });
  let glisse = null;
  cadre.addEventListener('pointerdown', (e) => {
    e.preventDefault(); cadre.setPointerCapture(e.pointerId);
    glisse = { coin: e.target.dataset.poignee || null, x0: e.clientX, y0: e.clientY, r0: { ...rognage }, boite: apercu.getBoundingClientRect() };
  });
  cadre.addEventListener('pointermove', (e) => {
    if (!glisse) return;
    const dx = ((e.clientX - glisse.x0) / glisse.boite.width) * 100, dy = ((e.clientY - glisse.y0) / glisse.boite.height) * 100;
    const r = { ...glisse.r0 }, MIN = 5, lim = (v, a, b) => Math.min(b, Math.max(a, v));
    if (!glisse.coin) { r.x = lim(r.x + dx, 0, 100 - r.w); r.y = lim(r.y + dy, 0, 100 - r.h); } else {
      if (glisse.coin.includes('w')) { const x = lim(r.x + dx, 0, r.x + r.w - MIN); r.w += r.x - x; r.x = x; }
      if (glisse.coin.includes('e')) r.w = lim(r.w + dx, MIN, 100 - r.x);
      if (glisse.coin.includes('n')) { const y = lim(r.y + dy, 0, r.y + r.h - MIN); r.h += r.y - y; r.y = y; }
      if (glisse.coin.includes('s')) r.h = lim(r.h + dy, MIN, 100 - r.y);
    }
    rognage = r; placerCadre();
  });
  ['pointerup', 'pointercancel'].forEach((ev) => cadre.addEventListener(ev, () => { glisse = null; }));

  /* Fin de parcours. */
  function telecharger(blob, nomFichier) {
    const a = document.createElement('a'); a.href = URL.createObjectURL(blob); a.download = nomFichier;
    document.body.appendChild(a); a.click(); a.remove(); setTimeout(() => URL.revokeObjectURL(a.href), 2000);
  }
  root.querySelector('[data-fin="telecharger"]').addEventListener('click', async () => {
    telecharger(await versBlob(courant), `${nom}-prepare.png`);
    if (svg) telecharger(new Blob([svg], { type: 'image/svg+xml' }), `${nom}-vectoriel.svg`);
  });
  // Feuille DTF : le visuel est posé à la largeur choisie sur une feuille 35 × 40 cm à 300 dpi (format attendu par la fiche).
  root.querySelector('[data-fin="dtf"]').addEventListener('click', () => enCours('Préparation de la feuille…', async () => {
    const k = Math.min(1, Math.sqrt(MAX_PX / (pixelsPour(35) * pixelsPour(40)))); // ≈ 277 dpi : sous la limite iOS, au-dessus des 250 dpi de la fiche
    const W = Math.floor(pixelsPour(35) * k), H = Math.floor(pixelsPour(40) * k);
    const lw = Math.min(W, Math.round(pixelsPour(Math.min(35, parseFloat(largeur.value) || 28)) * k));
    const lh = Math.min(H, Math.round((lw * courant.height) / courant.width));
    const lw2 = Math.round((lh * courant.width) / courant.height);
    const [c, x] = toile(W, H); x.drawImage(courant, Math.round((W - lw2) / 2), 0, lw2, lh);
    await window.ptxTransfert.deposer(await new Promise((ok) => c.toBlob(ok, 'image/png')), `${nom}-feuille-dtf.png`, 'dtf');
    location.href = '/products/feuille-dtf';
  }));
  root.querySelector('[data-fin="vetement"]').addEventListener('click', () => enCours('Envoi vers l’outil…', async () => {
    await window.ptxTransfert.deposer(await versBlob(courant), `${nom}.png`, 'perso');
    location.href = '/pages/personnaliser';
  }));
}
